
<button class="notes-button" color="primary" mat-fab (click)="onClick()">
  <mat-icon svgIcon="notes"></mat-icon>
</button>
